// @flow
import React from 'react';
import styled from 'styled-components';

const GoalcardItemContainer = styled.div`
  min-width: 250px;
  max-width: 290px;
  padding: 10px;
`;

const GoalcardItem = styled.div`
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0px 1px 25px 0px rgba(0, 0, 0, 0.13);
`;

type Props = {
  cardId: string,
  imageSrc: string,
  onSelect: Function
};

const Card = (props: Props) => {
  const { cardId, imageSrc, onSelect } = props;

  const url = `${process.env.REACT_APP_CARD_IMAGEBUCKET_URL}/${imageSrc}`;

  return (
    <GoalcardItemContainer>
      <GoalcardItem onClick={() => onSelect({ cardId, cardImageUrl: url })}>
        <img src={url} alt="Card" />
      </GoalcardItem>
    </GoalcardItemContainer>
  );
};

export default Card;
